<template>
  <HdCarousel
    ref="carousel"
    :key="`tags-list-${carouselComponentKey}`"
    :class="['tags-list', { 'tags-list--scrollable': !isTouchDevice }]"
    :options="carouselOptions"
  >
    <TagsItem
      v-for="(tag, index) in items"
      :key="`tag-${index}`"
      v-bind="tag"
      @click.native="handleItemClick(index)"
    />
  </HdCarousel>
</template>

<script>
import HdCarousel from '@/components/HdCarousel.vue';
import TagsItem from '@/components/dashboard/TagsItem.vue';
import { GETTER, MUTATION } from '@/store/CONSTANTS';

export default {
  name: 'TagsList',
  components: {
    TagsItem,
    HdCarousel,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    const isTouchDevice = !!('ontouchstart' in window || navigator.maxTouchPoints);

    return {
      isTouchDevice,
      carouselComponentKey: 0,
      carouselOptions: {
        percentPosition: false,
        freeScroll: !isTouchDevice,
        cellAlign: 'left',
        selectedAttraction: 0.2,
        friction: 0.8,
      },
    };
  },
  computed: {
    selectedTag() {
      return this.$store.getters[GETTER.DASHBOARD.SELECTED_TAG];
    },
  },
  watch: {
    items() {
      this.forceCarouselRerender();
    },
    selectedTag({ name }) {
      this.handleItemClick(this.items.findIndex(({ name: itemName }) => itemName === name));
    },
  },
  methods: {
    handleItemClick(index) {
      this.$refs.carousel.flickity.select(index);
      if (this.selectedTag.name !== this.items[index].name) {
        this.$store.commit(MUTATION.DASHBOARD.SET_SELECTED_TAG, this.items[index]);
      }
    },
    forceCarouselRerender() {
      this.carouselComponentKey += 1;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.tags-list {
  @include for('tablet') {
    display: none;
  }

  ::v-deep .tags-item:last-of-type {
    margin-right: $sp-m;

    @include for('tablet') {
      margin-right: $sp-l;
    }

    @include for('desktop-wide') {
      margin-right: $sp-xl + $sp-m;
    }
  }

  &--scrollable {
    white-space: nowrap;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;

    ::v-deep .flickity-viewport {
      overflow: visible;
    }
  }

  &--scrollable::-webkit-scrollbar {
    display: none;
  }
}
</style>
